// Component Selector Owner choices
export const COMPONENT_SELECTOR_OWNER_OPTIONS = [
  { id: 1, name: 'Both organisations' },
  { id: 2, name: 'My organisation' },
  { id: 3, name: 'Connected organisation' },
]

// Component Selector Owner choices with override option
export const COMPONENT_SELECTOR_OWNER_OVERRIDE_OPTIONS = [
  { id: 0, name: 'Use default view settings' },
  ...COMPONENT_SELECTOR_OWNER_OPTIONS,
]
